import Seo from "components/Seo";
import { useGetExpressCustomerSerial } from "../../../../../hooks/express/useGetExpressCustomerSerial";
import { useSearchParams } from "react-router-dom";

const ExpressOrderDetail = () => {
    const [searchParams] = useSearchParams();
    const num = searchParams.get("num") ?? "";

    const { data: detailData } = useGetExpressCustomerSerial({
        serial_number: num,
    });
    return (
        <>
            <Seo type="express" pageTitle="배송상세조회" />
            <div className="bg-white w-full items-center mt-3 mb-8 px-[50px] flex flex-col responsive1200:px-[2%]">
                <div className="w-full text-[19px] p-3 font-[500]">배송상세조회 - 주문번호({detailData?.order_info[0]})</div>
                <div className="flex w-full h-[80px] text-[15px] text-[#333] border-y border-[#ddd]">
                    <div className="min-w-[120px] h-full bg-[#f8f8f8] flex items-center justify-center border-r border-[#ddd]">
                        접수자정보
                    </div>
                    <div className="flex flex-col h-full min-w-[115px] border-r border-[#ddd]">
                        <div className="h-full flex items-center justify-center border-b border-[#ddd]">상호</div>
                        <div className="h-full flex items-center justify-center">부서명</div>
                    </div>
                    <div className="flex flex-col h-full min-w-[200px] border-r border-[#ddd]">
                        <div className="h-full flex items-center pl-4 border-b border-[#ddd] text-[#666]">
                            {detailData?.customer_info[0]}
                        </div>
                        <div className="h-full flex items-center pl-4 text-[#666]">{detailData?.customer_info[2]}</div>
                    </div>
                    <div className="flex flex-col h-full min-w-[115px] border-r border-[#ddd]">
                        <div className="h-full flex items-center justify-center border-b border-[#ddd]">연락처</div>
                        <div className="h-full flex items-center justify-center">담당</div>
                    </div>
                    <div className="flex flex-col h-full min-w-[218px]">
                        <div className="h-full flex items-center pl-4 border-b border-[#ddd] text-[#666]">
                            {detailData?.customer_info[1]}
                        </div>
                        <div className="h-full flex items-center pl-4 text-[#666]">{detailData?.customer_info[3]}</div>
                    </div>
                </div>
                <div className="flex w-full h-[80px] text-[15px] text-[#333] border-b border-[#ddd]">
                    <div className="min-w-[120px] h-full bg-[#f8f8f8] flex items-center justify-center border-r border-[#ddd]">
                        기사정보
                    </div>
                    <div className="flex flex-col h-full min-w-[115px] border-r border-[#ddd]">
                        <div className="h-full flex items-center justify-center border-b border-[#ddd]">기사고유정보</div>
                        <div className="h-full flex items-center justify-center">기사연락처</div>
                    </div>
                    <div className="flex flex-col h-full min-w-[200px]">
                        <div className="h-full flex items-center pl-4 border-b border-r border-[#ddd] text-[#666]">
                            {detailData?.rider_info[0]}
                        </div>
                        <div className="h-full flex items-center pl-4 text-[#666]">{detailData?.rider_info[2]}</div>
                    </div>
                    <div className="flex flex-col h-1/2 min-w-[115px] border-r border-[#ddd]">
                        <div className="h-full flex items-center justify-center border-b border-[#ddd]">기사이름</div>
                    </div>
                    <div className="flex flex-col h-1/2 min-w-[218px]">
                        <div className="h-full flex items-center pl-4 border-b border-[#ddd] text-[#666]">{detailData?.rider_info[1]}</div>
                    </div>
                </div>
                <div className="flex w-full h-[120px] text-[15px] text-[#333] border-b border-[#ddd]">
                    <div className="min-w-[120px] h-full bg-[#f8f8f8] flex items-center justify-center border-r border-[#ddd]">
                        주문정보
                    </div>
                    <div className="flex flex-col h-full">
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">주문번호</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.order_info[0]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">접수시간</div>
                            <div className="min-w-[218px] flex items-center pl-4 text-[#666]">{detailData?.order_info[1]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">배차시간</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.order_info[2]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">픽업시간</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.order_info[3]}</div>
                        </div>
                        <div className="flex h-full">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">배송사유</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.order_info[4]}</div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full h-[200px] text-[15px] text-[#333] border-b border-[#ddd]">
                    <div className="min-w-[120px] h-full bg-[#f8f8f8] flex items-center justify-center border-r border-[#ddd]">
                        배송지정보
                    </div>
                    <div className="flex flex-col h-full">
                        <div className="flex h-full border-b border-[#ddd]">
                            <div className="min-w-[115px]  border-r border-[#ddd] flex items-center justify-center">출발지동명</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.delivery_info[0]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">출발지연락처</div>
                            <div className="min-w-[218px] flex items-center pl-4 text-[#666]">{detailData?.delivery_info[1]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] whitespace-nowrap text-center border-r border-[#ddd] flex items-center justify-center">
                                출발지상호(이름)
                            </div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.delivery_info[2]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">도착지동명</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.delivery_info[3]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">도착지연락처</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.delivery_info[4]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] text-center border-r border-[#ddd] flex items-center justify-center">
                                도착지상호(이름)
                            </div>
                            <div className="w-[330px] flex items-center pl-4 text-[#666]">{detailData?.delivery_info[5]}</div>
                        </div>
                        <div className="flex h-full">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">전달내용</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.delivery_info[6]}</div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full h-[160px] text-[15px] text-[#333] border-b border-[#ddd]">
                    <div className="min-w-[120px] h-full bg-[#f8f8f8] flex items-center justify-center border-r border-[#ddd]">
                        배송/요금정보
                    </div>
                    <div className="flex flex-col h-full">
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">배송수단</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.cost_info[0]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">지불수단</div>
                            <div className="min-w-[218px] flex items-center pl-4 text-[#666]">{detailData?.cost_info[1]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">배송상태</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.cost_info[2]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">지급금액</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.cost_info[3]}</div>
                        </div>
                        <div className="flex border-b h-full border-[#ddd]">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">기본요금</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.cost_info[4]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">추가요금</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.cost_info[5]}</div>
                        </div>
                        <div className="flex h-full">
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">할인요금</div>
                            <div className="min-w-[200px] border-r border-[#ddd] flex items-center pl-4 text-[#666]">
                                {detailData?.cost_info[6]}
                            </div>
                            <div className="min-w-[115px] border-r border-[#ddd] flex items-center justify-center">탁송요금</div>
                            <div className="min-w-[200px] flex items-center pl-4 text-[#666]">{detailData?.cost_info[7]}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExpressOrderDetail;
